var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnsibleLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.879 127.868c0 70.455-57.11 127.565-127.566 127.565-70.45 0-127.566-57.11-127.566-127.565C.747 57.418 57.863.302 128.313.302c70.456 0 127.566 57.116 127.566 127.566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1918",
    d: "m130.46 78.229 33.012 81.476-49.864-39.278zm58.645 100.245-50.78-122.202c-1.449-3.524-4.347-5.39-7.865-5.39-3.524 0-6.634 1.866-8.083 5.39l-55.733 134.04h19.065l22.062-55.265 65.84 53.19c2.647 2.14 4.558 3.109 7.041 3.109 4.974 0 9.322-3.729 9.322-9.111 0-.876-.31-2.266-.87-3.761z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsibleLogoDark);
export default __webpack_public_path__ + "static/media/ansible-logo-dark.443d8d22ef5e8dd65b17ab9944f09d0a.svg";
export { ForwardRef as ReactComponent };